let config = {
  frc : {
    name    : 'FRC',
    apps    : 'frc',
    rest      : 'https://be.qrc.myriset.com/v01/',
    //rest    : 'https://api.ahmadsisfo.com/v01/',
    //rest      : 'https://rest.realcount.co.id/v01/',
    //rest    : 'https://apitrial.realcount.co.id/v01/',
    //rest    : 'https://api.aypro.pro/v01/',
    //rest      : 'https://api.pejuang02sumbar.com/v01/',
    
    //rest    : 'http://localhost/frc-yii/api/web/index.php/v01/',
    //rest    : 'https://btiapi.myriset.com/v01/',
    //rest    : 'https://api.aypro.pro/v01/',    
    //rest    : 'https://api.qrc.telekomatika.id/v01/',    
    
    console : false,
    
    title   : 'Quick RC',
    prefix  : 'frc3',
    color   : 'red darken-4',
    //color   : 'blue-grey',
    kpu     : 'https://pemilu2019.kpu.go.id/'
  },  
} 

/*import ls from '@/util/localStorage'

let apps = ls.get('apps');
if(!apps)
    ls.set('apps', 'main');
apps = apps ? apps : 'main';*/
export default config['frc'];

